

import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';

export default function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden p-8 sm:p-12"
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-6">Start with a pilot</h2>

            <p className="text-xl text-text-muted mb-10 max-w-xl mx-auto">
              We believe in proving value before asking for commitment.
            </p>

            <div className="bg-blue-50/50 rounded-2xl p-8 mb-10 border border-blue-100">
              <h3 className="text-lg font-semibold text-accent mb-6 uppercase tracking-wider">14-DAY PILOT PROGRAM</h3>
              <ul className="space-y-4 text-left max-w-md mx-auto">
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0">
                    <Check size={14} strokeWidth={3} />
                  </div>
                  <span className="text-primary font-medium">Define success metrics together</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0">
                    <Check size={14} strokeWidth={3} />
                  </div>
                  <span className="text-primary font-medium">Configure workflows for your team</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0">
                    <Check size={14} strokeWidth={3} />
                  </div>
                  <span className="text-primary font-medium">See real results before deciding</span>
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <a
                href="https://app.ianos.io"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-dark text-white text-lg font-bold px-10 py-4 rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-blue-500/25 w-full sm:w-auto"
              >
                Request a Demo
                <ArrowRight size={20} />
              </a>
              <p className="text-sm text-text-light">
                Get started in minutes. Sign up to begin your pilot.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-100 flex justify-center gap-8 text-sm text-text-muted">
              <span>No credit card required</span>
              <span>No pressure</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
